import { useEffect, useState, type ElementType } from 'react';

const FADE_MS = 5000;
const HIDE_MS = 5600;

export default function TimedNotice(props: {
  text: string | null | undefined;
  pulse?: number;
  className?: string;
  role?: 'status' | 'alert';
  as?: ElementType;
}): JSX.Element | null {
  const text = props.text?.trim() ? props.text : null;
  const [fading, setFading] = useState(false);
  const [hidden, setHidden] = useState(false);
  const Tag = props.as ?? 'p';

  useEffect(() => {
    if (!text) {
      setFading(false);
      setHidden(false);
      return;
    }
    setFading(false);
    setHidden(false);
    const fade = window.setTimeout(() => setFading(true), FADE_MS);
    const hide = window.setTimeout(() => setHidden(true), HIDE_MS);
    return () => {
      window.clearTimeout(fade);
      window.clearTimeout(hide);
    };
  }, [text, props.pulse]);

  if (!text || hidden) return null;

  const className = [props.className, fading ? 'world-status-fade' : ''].filter(Boolean).join(' ');

  return (
    <Tag className={className || undefined} role={props.role ?? 'status'} style={{ transition: 'opacity 0.6s ease' }}>
      {text}
    </Tag>
  );
}
